import { IconedHeader } from "components/display/IconedHeader";
import * as S from "./styles";

import { ReactComponent as CarIcon } from "assets/car.svg";
import { ReactComponent as HomeIcon } from "assets/home.svg";
import { IPolicemenValues } from "interfaces/Policeman";
import { usePolicemanRegister } from "contexts/register/PolicemanContext";
import { MoneyInput } from "components/MoneyInput";

type Props = {
  updateValuesData: {
    patrimonialValues?: IPolicemenValues;
    vehicleValues?: IPolicemenValues;
  };
};

type HandleValueChangeParams = {
  key: keyof IPolicemenValues;
  eventValue: number;
  type?: "patrimony" | "vehicle";
};

export function PolicemanValuesForm({ updateValuesData }: Props) {
  const { policeman, setPoliceman, errors, removeError } =
    usePolicemanRegister();

  const vehicleValues = updateValuesData?.vehicleValues;
  const patrimonialValues = updateValuesData?.patrimonialValues;

  function handleValueChange(params: HandleValueChangeParams) {
    const { key, eventValue, type = "vehicle" } = params;

    const policemenValueKey =
      type === "patrimony" ? "patrimonialValues" : "vehicleValues";

    const value = Number(eventValue);

    setPoliceman((policemen) => {
      policemen[policemenValueKey][key] = value;
      return policemen;
    });
  }

  return (
    <S.Wrapper>
      <S.Column data-cy="vehicleOccurrence">
        <IconedHeader icon={<CarIcon />} title="Para ocorrência veicular" />

        <S.FormBody>
          <S.FormGroup>
            <MoneyInput
              id="vehicle_additional_km"
              name="vehicle_additional_km"
              label="Valor por KM adicional"
              error={errors["policeman.vehicleValues.additionalKm"]}
              onFocus={() =>
                removeError("policeman.vehicleValues.additionalKm")
              }
              defaultValue={
                policeman?.vehicleValues?.additionalKm ??
                vehicleValues?.additionalKm
              }
              onCurrencyChange={(value) => {
                handleValueChange({
                  eventValue: value,
                  key: "additionalKm",
                });
              }}
              required
            />
          </S.FormGroup>

          <S.FormGroup>
            <MoneyInput
              id="vehicle_additional_hour"
              name="vehicle_additional_hour"
              label="Valor por hora adicional"
              error={errors["policeman.vehicleValues.additionalHour"]}
              onFocus={() =>
                removeError("policeman.vehicleValues.additionalHour")
              }
              defaultValue={
                policeman?.vehicleValues?.additionalHour ??
                vehicleValues?.additionalHour
              }
              onCurrencyChange={(value) => {
                handleValueChange({
                  eventValue: value,
                  key: "additionalHour",
                });
              }}
              required
            />
          </S.FormGroup>

          <S.FormGroup>
            <MoneyInput
              id="vehicle_exit_value"
              name="vehicle_exit_value"
              label="Valor de saida do PR"
              error={errors["policeman.vehicleValues.exitValue"]}
              onFocus={() => removeError("policeman.vehicleValues.exitValue")}
              defaultValue={
                policeman?.vehicleValues?.exitValue ?? vehicleValues?.exitValue
              }
              onCurrencyChange={(value) => {
                handleValueChange({
                  eventValue: value,
                  key: "exitValue",
                });
              }}
              required
            />
          </S.FormGroup>
          <S.FormGroup>
            <MoneyInput
              id="mileageKm"
              name="mileageKm"
              label="Franquia por KM *"
              defaultValue={
                policeman?.vehicleValues?.mileageKm ?? vehicleValues?.mileageKm
              }
              onCurrencyChange={(value) =>
                handleValueChange({
                  eventValue: value,
                  key: "mileageKm",
                })
              }
              required
              error={errors["policeman.vehicleValues.mileageKm"]}
            />
          </S.FormGroup>
        </S.FormBody>
      </S.Column>

      <S.Column data-cy="patrimonialOccurrence">
        <IconedHeader icon={<HomeIcon />} title="Para ocorrência patrimonial" />

        <S.FormBody>
          <S.FormGroup>
            <MoneyInput
              id="additional_km"
              name="additional_km"
              label="Valor por KM adicional"
              error={errors["policeman.patrimonialValues.additionalKm"]}
              onFocus={() =>
                removeError("policeman.patrimonialValues.additionalKm")
              }
              defaultValue={
                policeman?.patrimonialValues?.additionalKm ??
                patrimonialValues?.additionalKm
              }
              onCurrencyChange={(value) => {
                handleValueChange({
                  eventValue: value,
                  key: "additionalKm",
                  type: "patrimony",
                });
              }}
              required
            />
          </S.FormGroup>

          <S.FormGroup>
            <MoneyInput
              id="additional_hour"
              name="additional_hour"
              label="Valor por hora adicional"
              error={errors["policeman.patrimonialValues.additionalHour"]}
              onFocus={() =>
                removeError("policeman.patrimonialValues.additionalHour")
              }
              defaultValue={
                policeman?.patrimonialValues?.additionalHour ??
                patrimonialValues?.additionalHour
              }
              onCurrencyChange={(value) => {
                handleValueChange({
                  eventValue: value,
                  key: "additionalHour",
                  type: "patrimony",
                });
              }}
              required
            />
          </S.FormGroup>

          <S.FormGroup>
            <MoneyInput
              id="exit_value"
              name="exit_value"
              label="Valor de saida do PR"
              error={errors["policeman.patrimonialValues.exitValue"]}
              onFocus={() =>
                removeError("policeman.patrimonialValues.exitValue")
              }
              defaultValue={
                policeman?.patrimonialValues?.exitValue ??
                patrimonialValues?.exitValue
              }
              onCurrencyChange={(value) => {
                handleValueChange({
                  eventValue: value,
                  key: "exitValue",
                  type: "patrimony",
                });
              }}
              required
            />
          </S.FormGroup>
          <S.FormGroup>
            <MoneyInput
              id="mileageKm2"
              name="mileageKm2"
              label="Franquia por KM *"
              defaultValue={
                policeman?.patrimonialValues?.mileageKm ??
                patrimonialValues?.mileageKm
              }
              onCurrencyChange={(value) =>
                handleValueChange({
                  eventValue: value,
                  key: "mileageKm",
                  type: "patrimony",
                })
              }
              required
              error={errors["policeman.patrimonialValues.mileageKm"]}
            />
          </S.FormGroup>
        </S.FormBody>
      </S.Column>
    </S.Wrapper>
  );
}
